import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useState } from 'react';
import { useTable } from '../utils/hooks.js';
import NonRowGroups from './NonRowGroups.js';
import RowGroup from './RowGroup.js';
import RowGroups from './RowGroups.js';

/**
 * RecursiveRowGroups - Recursion for Row Grouping
 * @param {object} props
 * @param {string} props.classesForColumns classes from columnDefs
 * @param {array} props.childRowGroupData children data created from parent
 * @param {string} props.id unique id passed from and related to parent
 * @param {any} props.parentRows rows that are generated from the parent
 * @param {string} props.parentValue the original from parent value
 * @param {number} props.parentRowGroupIndex created from the index order of a column def
 * @param {string} props.groupId unique group id from the first parent
 * @returns {any}
 */

function RecursiveRowGroups(_ref) {
  var _columnDefs$parentRow, _columnDefs;
  var classesForColumns = _ref.classesForColumns,
    childRowGroupData = _ref.childRowGroupData,
    id = _ref.id,
    parentRows = _ref.parentRows,
    parentValue = _ref.parentValue,
    parentRowGroupIndex = _ref.parentRowGroupIndex,
    groupId = _ref.groupId;
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    columns = _useTable$state.columns;
    _useTable$state.rowSelection;
  var columnDefs = columns.columnDefs;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expandedRowGroup = _useState2[0],
    setExpandedRowGroup = _useState2[1];
  var isExpandable = !!((_columnDefs$parentRow = columnDefs[parentRowGroupIndex]) !== null && _columnDefs$parentRow !== void 0 && _columnDefs$parentRow.rowGroup);
  var isChildRowGroup = !!((_columnDefs = columnDefs[parentRowGroupIndex + 1]) !== null && _columnDefs !== void 0 && _columnDefs.rowGroup);
  var childRowGroupIndex = parentRowGroupIndex + 1;

  // Do recursion on expandable rows
  if (isExpandable) {
    return [/*#__PURE__*/React__default.createElement(RowGroup, {
      groupId: groupId,
      columnDefs: columns.columnDefs,
      classesForColumns: classesForColumns,
      id: id,
      isRowGroupSelected: !!expandedRowGroup,
      parentValue: parentValue,
      onSelectCallback: setExpandedRowGroup,
      parentRows: parentRows,
      parentRowGroupIndex: parentRowGroupIndex,
      key: "".concat(parentValue, "-rowGroup}"),
      childRowGroupData: childRowGroupData
    }), /*#__PURE__*/React__default.createElement(RowGroups, {
      childRowGroupData: childRowGroupData,
      childRowGroupIndex: childRowGroupIndex,
      columnDefs: columns.columnDefs,
      classesForColumns: classesForColumns,
      id: id,
      isChildRowGroup: isChildRowGroup,
      parentRowGroupIndex: parentRowGroupIndex,
      parentRows: parentRows,
      expandedRowGroup: expandedRowGroup,
      key: "".concat(parentValue, "-rowGroups"),
      groupId: groupId
    }), /*#__PURE__*/React__default.createElement(NonRowGroups, {
      parentRows: parentRows,
      parentRowGroupIndex: parentRowGroupIndex,
      columnDefs: columns.columnDefs,
      classesForColumns: classesForColumns,
      id: id,
      isChildRowGroup: isChildRowGroup,
      key: "".concat(parentValue, "-nonGroupRow"),
      expandedRowGroup: expandedRowGroup
    })];
  }
}

export { RecursiveRowGroups as default };
